import type { ReactNode } from 'react'
import styled from 'styled-components'

const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
`

const Title = styled.h2`
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  margin: 0 0 16px;
  color: ${({ theme }) => theme.color.neutral.color3};
`

// Segmented radio groups (Status, Allergies, GP connect, …) render as
// equal-width pills filling the field column, matching Figma. Spread onto a
// `<Field type="radios">`.
export const segmentedRadio = {
  style: { gap: 16 },
  optionFieldStyle: { flex: '1 1 0', minWidth: 0, marginRight: 0 }
}

// Fields sit in a constrained, left-aligned column (label + input ~720px) so
// inputs don't stretch the full card width — matches the Figma layout.
const Body = styled.div`
  max-width: 752px;
`

// Uniform vertical spacing between field rows within a card. Use this to wrap
// a card's fields so every row is evenly spaced (legacy fields each carried
// their own ad-hoc margins, which read as inconsistent gaps).
export const CardFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

type EditProfileCardProps = {
  title: string
  children: ReactNode
  testId?: string
}

const EditProfileCard = ({ title, children, testId }: EditProfileCardProps) => (
  <Card className="lmc-card" data-testid={testId}>
    <Title>{title}</Title>
    <Body>{children}</Body>
  </Card>
)

export default EditProfileCard
